export var ProgramStdoutTypes;
(function (ProgramStdoutTypes) {
    ProgramStdoutTypes["STDOUT_START"] = "STDOUT_START";
    ProgramStdoutTypes["STDOUT_MSG"] = "STDOUT_MSG";
})(ProgramStdoutTypes || (ProgramStdoutTypes = {}));
//# sourceMappingURL=ProgramStdout.js.map